(() => {
  const restoreTimers = new WeakMap();
  const announce = (button) => {
    if (!button) return;
    const label = button.querySelector('span:not(.sold-out-message):not(.icon-wrap)') || button;
    if (!label.dataset.bwOriginalLabel) label.dataset.bwOriginalLabel = label.textContent.trim();
    if (restoreTimers.has(button)) clearTimeout(restoreTimers.get(button));
    label.textContent = 'Added to cart ✓';
    button.classList.add('bw-cart-added');
    button.setAttribute('aria-label', 'Added to cart');
    let status = button.parentElement?.querySelector('.bw-cart-feedback-status');
    if (!status) {
      status = document.createElement('span');
      status.className = 'bw-cart-feedback-status visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      button.insertAdjacentElement('afterend', status);
    }
    status.textContent = 'Added to cart';
    document.querySelectorAll('.header-cart, #cart-icon-bubble').forEach((cart) => {
      cart.classList.remove('bw-cart-bounce');
      void cart.offsetWidth;
      cart.classList.add('bw-cart-bounce');
      setTimeout(() => cart.classList.remove('bw-cart-bounce'), 700);
    });
    restoreTimers.set(button, setTimeout(() => {
      if (!button.isConnected) return;
      label.textContent = label.dataset.bwOriginalLabel;
      button.classList.remove('bw-cart-added');
      button.removeAttribute('aria-label');
      if (status.isConnected) status.textContent = '';
      restoreTimers.delete(button);
    }, 2400));
  };
  document.addEventListener('berrigan:cart-added', (event) => announce(event.detail?.button));
})();
